/**
 * "You Might Also Like" arrow-scroll controls — scrolls the fetched
 * recommendations fragment's .pcr__grid track (see
 * product-recommendations-related.liquid) left/right by roughly one card's
 * width per click, and disables an arrow once its end is reached. The
 * fragment loads async (product-crosssell.js), so the track is (re)watched
 * with a MutationObserver rather than assumed present at DOMContentLoaded.
 */
(function () {
  'use strict';

  function initArrows(root) {
    var prevBtn = root.querySelector('[data-role="scroll-prev"]');
    var nextBtn = root.querySelector('[data-role="scroll-next"]');
    var trackWrap = root.querySelector('[data-role="scroll-track"]');
    if (!prevBtn || !nextBtn || !trackWrap) return;

    function getTrack() {
      return trackWrap.querySelector('.pcr__grid');
    }

    function syncState() {
      var track = getTrack();
      if (!track) {
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 2;
    }

    function scrollByCard(direction) {
      var track = getTrack();
      if (!track) return;
      var card = track.querySelector(':scope > *');
      var amount = card ? card.getBoundingClientRect().width + 16 : 240;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      window.setTimeout(syncState, 350);
    }

    prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    nextBtn.addEventListener('click', function () { scrollByCard(1); });

    var track = getTrack();
    if (track) {
      track.addEventListener('scroll', syncState);
      syncState();
    } else {
      // Fragment hasn't loaded yet — watch for it, then wire up scroll sync.
      var observer = new MutationObserver(function () {
        var loadedTrack = getTrack();
        if (loadedTrack) {
          loadedTrack.addEventListener('scroll', syncState);
          syncState();
          observer.disconnect();
        }
      });
      observer.observe(trackWrap, { childList: true, subtree: true });
    }
  }

  document.querySelectorAll('.pcxc').forEach(initArrows);
})();
